import React, { createContext, useContext, useState, PropsWithChildren } from "react"

interface ConnectionErrorProps {
  isConnectionError: boolean
  showConnectionError: (flg: boolean) => void
}

const ConnectionErrorContext = createContext<ConnectionErrorProps | undefined>(undefined)

export const ConnectionErrorProvider: React.FC<PropsWithChildren<{ children: React.ReactNode }>> = ({ children }) => {
  const [isConnectionError, setConnectionError] = useState<boolean>(false)

  const showConnectionError = (flg: boolean) => {
    setConnectionError(flg)
  }

  return (
    <ConnectionErrorContext.Provider value={{ isConnectionError, showConnectionError }}>
      {children}
    </ConnectionErrorContext.Provider>
  )
}

export const useConnectionError = () => {
  const context = useContext(ConnectionErrorContext)
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider")
  }
  return context
}
